import { Link } from "react-router-dom";
import { PageHeader } from "../components/PageHeader";

export default function NotFound() {
  return (
    <div data-testid="not-found-page">
      <PageHeader eyebrow="404" title="This page has wandered off." body="The page you are looking for does not exist." />
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-8 lg:px-16">
        <Link
          to="/"
          data-testid="not-found-home-link"
          className="inline-block bg-stone-900 px-9 py-4 font-mono text-[11px] font-medium uppercase tracking-[0.25em] text-stone-50 transition-colors duration-300 hover:bg-emerald-900"
        >
          Back Home
        </Link>
      </div>
    </div>
  );
}
